import { backupPrimitivesByProjectUuid, deleteBackupByProjectUuidAndTime, getCollectionBackupsByProjectUuid, loadBackupByProjectUuidAndTime } from "@/api/geometry/primitive";
import SideBarTool from "@/commons/components/side-bar-tool";
import { SideBarBtnType } from "@/commons/enums/side-bar-btn-type";
import { getDetailDateByStamp } from "@/commons/utils/date-utils";
import { Modal, Spin } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import "./index.less"
import classNames from "classnames";
import TnModal from "@/commons/widget/base-modal";
import TnMessage from "@/commons/widget/message";
import { emitter } from "@/App";
import { Emit_Event } from "@/commons/enums/emit-event";

export default function BackupPanel(second) {

    const { projectUuid } = useParams()

    // 备份时间戳列表
    const [backupList, setBackupList] = useState<number[]>([])
    // 激活的时间戳
    const [activeItem, setActiveItem] = useState<number>()
    // loading
    const [loading, setLoading] = useState<boolean>(false); // loading

    useEffect(() => {
        generateData()
    }, [projectUuid])

    const generateData = () => {
        if (!projectUuid) return
        getCollectionBackupsByProjectUuid(projectUuid).then(res => {
            let list: number[] = res.data || []
            list.sort((a, b) => b - a);
            setBackupList(list || [])
        })
    }

    const onDeleteClick = () => {
        if (!activeItem) {
            TnMessage.warning("未选中备份文件")
            return
        }
        TnModal().baseModal({
            title: "删除备份",
            content: "是否删除所选备份文件？",
            onOk() {
                setLoading(true)
                deleteBackupByProjectUuidAndTime(projectUuid, activeItem).then(res => {
                    let newList = backupList.filter(item => item != activeItem)
                    setBackupList([...newList])
                }).finally(() => {
                    setLoading(false)
                    setActiveItem(null)
                    Modal.destroyAll();
                })
            },
            onCancel() {
                Modal.destroyAll();
            },
            closable: true,
        })
    }

    // 添加备份
    const onAddBtnClick = () => {
        TnModal().baseModal({
            title: "添加备份",
            content: "是否备份当前项目所有图元、图层、坐标系信息？",
            onOk() {
                setLoading(true)
                backupPrimitivesByProjectUuid(projectUuid).then(res => {
                    setBackupList([res.data, ...backupList])
                }).finally(() => {
                    setLoading(false)
                    Modal.destroyAll();
                })
            },
            onCancel() {
                Modal.destroyAll();
            },
            closable: true,
        })
    }

    // 载入备份文件
    const loadBackupOnClick = (e, item: number) => {
        e.stopPropagation();
        TnModal().baseModal({
            title: "载入备份",
            content: "载入备份将会覆盖当前所有的图元、图层、坐标系，是否继续？",
            onOk() {
                loadBackupByProjectUuidAndTime(projectUuid, item).then(res => {
                    emitter.emit(Emit_Event.UPDATE_MODELS)
                }).catch((e) => {
                    TnMessage.error("载入失败！")
                })
                Modal.destroyAll();
            },
            onCancel() {
                Modal.destroyAll();
            },
            closable: true,
        })
    }


    return (
        <Spin spinning={loading}>
            <div className="backup-panel-main">
                <SideBarTool
                    activeBtnList={[SideBarBtnType.DELETE, SideBarBtnType.ADD]}
                    onDeleteBtnClick={onDeleteClick}
                    onAddBtnClick={onAddBtnClick}
                />
                <div className="backup-list">
                    {backupList?.map((item, index) => (
                        <div className={classNames({
                            "list-item": true,
                            "list-item-active": activeItem == item
                        })}
                            onClick={() => {
                                if (activeItem == item) {
                                    setActiveItem(null)
                                } else {
                                    setActiveItem(item)
                                }
                            }}
                            key={index}>
                            {getDetailDateByStamp(item)}
                            {activeItem == item && (
                                <div className="load-backup-btn" onClick={(e) => { loadBackupOnClick(e, item) }}>
                                    载入备份
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </Spin>
    )
}